var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid main-place mt-5 mb-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('img',{staticClass:"avatar",attrs:{"src":_vm.avatarUrl}})]),_vm._v(" "),_c('div',{staticClass:"col-8"},[_vm._v("\n      Cześć "+_vm._s(_vm.user)),_c('br'),_vm._v(" "),_c('span'),_vm._v("online"),_c('br'),_vm._v("\n      "+_vm._s(_vm.currentStoreName)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aa37eec","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/place/MainPlace.vue
// module id = 947
// module chunks = 0